import $ from 'jquery'
import { debounce, formatMoney } from './helpers'
import axios from 'axios'

$(document).on('click', '.main-cart-gift-header', function () {
  $(this).next().slideToggle()
})

$(document).on('click', '.main-cart-item .quantity-selector button', async function () {
  // Get body
  const root = $(this).parents('.main-cart-item')
  const quantity = Number($(this).parent().find('input').val())
  const id = root.attr('data-line-item-key')

  // Update cart
  const res = await fetch('/cart/change.js', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id,
      quantity,
    }),
  })

  const cart = await res.json()

  // Update page
  const subtotal = formatMoney(cart.total_price).replace('.00', '')
  const lineItem = cart.items[root.index()]
  const lineItemPrice = formatMoney(lineItem.final_line_price).replace('.00', '')

  $('#header-cart-count').text(cart.item_count)
  $('.main-cart-totals-row-flex-subtotal').text(subtotal)
  root.find('.main-cart-item-min-footer-line-price').text(lineItemPrice)
})

$(document).on('click', '.main-cart-item-remove', async function (e) {
  e.preventDefault()

  // Get body
  const root = $(this).parents('.main-cart-item')
  const id = root.attr('data-line-item-key')
  const quantity = 0

  // Update cart
  const res = await fetch('/cart/change.js', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id,
      quantity,
    }),
  })

  const cart = await res.json()

  if (cart.item_count === 0) {
    const emptyHtml = `<div class='main-cart-empty'>
      <h1>Your cart is empty</h1>
      <a class='button' href='/collections'>Shop our products</a>
    </div>`

    $('.main-cart .width').html(emptyHtml)
  } else {
    // Update page
    const subtotal = formatMoney(cart.total_price).replace('.00', '')
    $('#header-cart-count').text(cart.item_count)
    $('.main-cart-totals-row-flex-subtotal').text(subtotal)
    root.remove()
  }
})

$('.main-cart-gift-body-textarea').on(
  'keyup',
  debounce(async function () {
    await fetch('/cart/update.js', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: $(this).val(),
      }),
    })
  }, 300)
)

$('#ccc').on('click', async function (e) {
  try {
    await syncEmbroidery()
  } catch (err) {}

  window.location.href = '/checkout'
})

async function syncEmbroidery() {
  // Get cart ajax
  const res = await axios.get('/cart.json')

  // Count embroideries
  let total = 0
  let embroideryTotal = 0

  res.data.items.forEach((item) => {
    if (item.properties && item.properties['Embroidery text']) {
      total += item.quantity
    } else if (item.id === 40890756530242) {
      embroideryTotal += item.quantity
    }
  })

  // Update embroidery if some
  if (total !== embroideryTotal) {
    await axios.post('/cart/update.js', {
      updates: {
        40890756530242: total,
      },
    })
  }
}
